import { connect } from "react-redux";
import FinanceContractList from "./financeContractList";
import { bindActionCreators } from "redux";
import { getApprovedSaleListing } from "services/redux/sales/financeContractList/action";

import {
  fetchZones,
  getListFilterData,
} from "services/redux/sales/financeContract/action";

const mapStateToProps = (state) => ({
  postSalesList: state.approvedSalesListReducer.postSalesList,
  getFetchZones: state.preSalesListReducer.getFetchZones,
  filterDropdownList: state.preSalesListReducer.filterDropdownList,

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getListFilterData,
      fetchZones,
      getApprovedSaleListing,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(FinanceContractList);
